import { SelectInputOption } from '@/components/inputs/SelectInput';
import { Control, FieldValues } from 'react-hook-form';
import { Save as SaveIcon } from '@mui/icons-material';
import {
  FormTextInput,
  FormSelectInput,
  FormDateInput,
  FormSubmitButton,
  FormCancelButton,
} from '@/components';

export type ServiceFormMode = 'create' | 'edit';

export interface ServiceFormProps<T extends FieldValues> {
  mode: ServiceFormMode;
  control: Control<T>;
  
  handleSubmit: (e?: React.BaseSyntheticEvent) => void | Promise<void>;
  vehicleTypesOptions: SelectInputOption[];
  serviceTypesOptions: SelectInputOption[];
  businessOptions?: SelectInputOption[];
  vehicleTypesLoading?: boolean;
  serviceTypesLoading?: boolean;
  title: string;
  onCancel: () => void;
  submitLabel: string;
  isSubmitting?: boolean;
  submitDisabled?: boolean;
}

function ServiceForm<T extends FieldValues>({
  mode,
  control,
  handleSubmit,
  vehicleTypesOptions,
  serviceTypesOptions,
  businessOptions = [],
  vehicleTypesLoading = false,
  serviceTypesLoading = false,
  title,
  onCancel,
  submitLabel,
  isSubmitting = false,
  submitDisabled = false,
}: ServiceFormProps<T>) {

  const isCreate = mode === 'create';

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full p-[50px] flex flex-col bg-white rounded-[5px] shadow-[0_0_4px_rgba(0,0,0,0.1)] gap-5"
    >
      <h1 className="mb-[15px] font-bold text-2xl">{title}</h1>

      {isCreate && (
        <div className="flex gap-3">
          <div className="flex-1">
            <FormSelectInput
              control={control as Control<FieldValues>}
              name="businessId"
              placeholder="Negocio"
              options={businessOptions}
              required
            />
          </div>
        </div>
      )}

      <div className="flex gap-3">
        <div className="flex-1">
          <FormSelectInput
            control={control as Control<FieldValues>}
            name="vehicleTypeId"
            placeholder={vehicleTypesLoading ? 'Cargando...' : 'Tipo de vehículo'}
            options={vehicleTypesOptions}
            required
          />
        </div>
        <div className="flex-1">
          <FormSelectInput
            control={control as Control<FieldValues>}
            name="serviceTypeId"
            placeholder={serviceTypesLoading ? 'Cargando...' : 'Tipo de servicio'}
            options={serviceTypesOptions}
            required
          />
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <FormTextInput
            control={control as Control<FieldValues>}
            name="fee"
            placeholder="Tarifa"
            type="number"
            required
          />
        </div>
        <div className="flex-1">
          <FormTextInput
            control={control as Control<FieldValues>}
            name="min"
            placeholder="Mínimo"
            type="number"
            required
          />
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <FormDateInput
            control={control as Control<FieldValues>}
            name="validFrom"
            placeholder="Vigencia desde"
            required
          />
        </div>
        <div className="flex-1">
          <FormDateInput
            control={control as Control<FieldValues>}
            name="validTo"
            placeholder="Vigencia hasta"
            required
          />
        </div>
      </div>

      <div className="flex flex-wrap gap-3 pt-2 justify-end">
        <FormCancelButton action={onCancel} disabled={isSubmitting} />
        <FormSubmitButton
          label={submitLabel}
          icon={<SaveIcon />}
          action={() => handleSubmit()}
          disabled={submitDisabled}
          isLoading={isSubmitting}
        />
      </div>
    </form>
  );
}

export default ServiceForm;
